<template>
    <div class="footer">
        <div  class="copyright"> <strong>Copyright © {{new Date().getFullYear()}} <a href="#">{{appInfo.company ? appInfo.company :'CloudGo'}}</a>.</strong> All rights reserved.</div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        props:{
            appInfo:{
                type:Object,
                default:function () {
                    return {};
                }
            }
        }
    }
</script>

<style lang="scss" scoped>


    .footer{
        border-top: 1px solid #ebeef5;
    }

    .copyright{
        text-align: right;
        padding-right: 20px;

        a{
            text-decoration: none;
            color: #0054a3;
        }

    }

</style>